import React from 'react';

import { Svg } from '@lglp/components';

import { ArrowOrientation } from './Arrow';
import styles from './CTAArrow.module.scss';

const CTAArrow: React.FC<CTAArrowProps> = ({
  orientation,
  className,
  ...rest
}) => {
  let orientationClassName = styles.right;
  switch (orientation) {
    case ArrowOrientation.LEFT: {
      orientationClassName = styles.left;
      break;
    }
    case ArrowOrientation.TOP: {
      orientationClassName = styles.top;
      break;
    }
    case ArrowOrientation.BOTTOM: {
      orientationClassName = styles.bottom;
      break;
    }
    case ArrowOrientation.RIGHT:
    default: {
      orientationClassName = styles.right;
      break;
    }
  }
  return (
    <Svg className={[styles.arrow, orientationClassName, className]} {...rest}>
      <path
        className={styles.arrowIcon}
        d="M.606 8.308h13.095l-4.953 4.969h3.501l6.192-6.21-6.192-6.21H8.748l4.953 4.968H.606v2.483z"
      />
    </Svg>
  );
};

type CTAArrowProps = {
  orientation?: ArrowOrientation;
  className?: string;
};

export default CTAArrow;
